import React from 'react';
import { MenuProvider } from './src/context/MenuContext'; // Adjust the path
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import './src/assets/scss/main.global.scss';

export const wrapRootElement = ({ element }) => {
  return <MenuProvider>{element}</MenuProvider>;
};
